import Button from "components/base/Button";
import { useModals } from "ModalProvider";
import { getOriginalFileName } from "utils/string";
import { SUPPLIER_CERTIFICATES } from "./const";
import SupplierCertificatesForm from "./SupplierCertificatesForm";

function normalizeCertificates(certificates) {
  if (!certificates) return {};

  if (Array.isArray(certificates)) {
    return certificates.reduce((acc, item) => {
      if (!item?.name || !item?.file_url) return acc;
      acc[item.name] = item.file_url;
      return acc;
    }, {});
  }

  if (typeof certificates === "object") return certificates;

  return {};
}

const CertificatesView = ({ supplier }) => {
  const certificates = normalizeCertificates(
    supplier.certificates ? JSON.parse(supplier.certificates) : {},
  );
  const certificateItems = SUPPLIER_CERTIFICATES.map((cert) => [
    cert,
    certificates[cert],
  ]).filter(([, url]) => !!url);

  const modal = useModals();

  function editHandler() {
    modal.present({
      title: "Edit Supplier Certificates",
      children: (
        <SupplierCertificatesForm
          supplierId={supplier.id}
          originalCertificates={certificates}
          onSaved={modal.hide}
        />
      ),
      isBeingPresented: true,
    });
  }

  return (
    <div className="card">
      <div className="flex justify-between items-baseline">
        <h5>Supplier Certificates</h5>
        <div>
          <Button onClick={editHandler}>Edit</Button>
        </div>
      </div>
      <div className="mt-2">
        {certificateItems.length > 0 ? (
          <div className="-mx-2">
            <table className="w-full">
              <tbody>
                {certificateItems.map(([name, url], index) => (
                  <tr
                    key={index}
                    className="border-y border-gray-100 dark:border-gray-700"
                  >
                    <td className="py-2 align-baseline">
                      <label>{name}:</label>
                    </td>
                    <td className="py-2 w-full">
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        📄 {getOriginalFileName(url)}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No certificates available.</p>
        )}
      </div>
    </div>
  );
};

export default CertificatesView;
